import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import moment from 'moment';

const InteractionsRepository = RepositoryFactory.get('interactions');

// initial state
// shape: [{ id, quantity }]
const state = {
    interactionTemplates: [],
    lastUpdateTime: null
};

// getters
const getters = {
    interactionTemplates: (state) => {
        return state.interactionTemplates;
    },
    lastUpdateTime: (state) => {
        return state.lastUpdateTime;
    }
};

const CACHE_TIME_MS = 2 * 60 * 1000; // 2 minutes in ms

// actions
const actions = {
    async fetchInteractionTemplates({commit, getters}, forceReload = false) {
        if (forceReload || getters.interactionTemplates.length === 0 || (getters.lastUpdateTime === null ||
            (moment.valueOf()) - CACHE_TIME_MS > getters.lastUpdateTime)) {
            const {data} = await InteractionsRepository.getInteractionTemplates();
            commit('setLastUpdateTime');
            data.forEach(int => {
                int.action = [
                    'edit',
                    'copy',
                    'delete'
                ];
            });
            commit('setInteractionTemplates', {interactions: data});
        }
    }
};

// mutations
const mutations = {
    setInteractionTemplates(state, {interactions}) {
        state.interactionTemplates = interactions;
    },
    setLastUpdateTime(state) {
        state.lastUpdateTime = moment().valueOf();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}